import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import jwt_decode from "jwt-decode";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";

const List = () => {
  const token        = localStorage.getItem("jwtToken");
  const decodedToken = token ? jwt_decode(token) : null;
  const user_id      = decodedToken ? decodedToken.user_id : null;

  const [data,      setData]      = useState([]);
  const [summary,   setSummary]   = useState(null);
  const [limit,     setLimit]     = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [search,    setSearch]    = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate,   setEndDate]   = useState("");
  const currentPage = useRef(1);

  // ✅ AUTO FETCH
  useEffect(() => {
    getPaginatedUsers();
  }, [search, startDate, endDate, limit]);

  function getPaginatedUsers() {
    const params = new URLSearchParams({
      page: currentPage.current,
      limit,
      user_id,
      ...(search && { search }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
    });

    fetch(`${apiConfig.baseURL}/api/agent/affiliate_deposit_list?${params}`)
      .then((res) => res.json())
      .then((data) => {
        setPageCount(data.pageCount);
        setData(data.result);
        setSummary(data.summary);
      });
  }

  function handlePageClick(e) {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  }

  function handleSearch(e) {
    e.preventDefault();
    currentPage.current = 1;
    getPaginatedUsers();
  }

  function handleReset() {
    setSearch("");
    setStartDate("");
    setEndDate("");
    currentPage.current = 1;
  }

  function setThisWeek() {
    const now = new Date();
    const day = now.getDay();
    const diffToMonday = (day === 0 ? -6 : 1 - day);

    const monday = new Date(now);
    monday.setDate(now.getDate() + diffToMonday);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const fmt = (d) => d.toISOString().split("T")[0];

    setStartDate(fmt(monday));
    setEndDate(fmt(sunday));
    currentPage.current = 1;
  }

  function setLastWeek() {
    const now = new Date();
    const day = now.getDay();
    const diffToLastMonday = (day === 0 ? -13 : 1 - day - 7);

    const lastMonday = new Date(now);
    lastMonday.setDate(now.getDate() + diffToLastMonday);

    const lastSunday = new Date(lastMonday);
    lastSunday.setDate(lastMonday.getDate() + 6);

    const fmt = (d) => d.toISOString().split("T")[0];

    setStartDate(fmt(lastMonday));
    setEndDate(fmt(lastSunday));
    currentPage.current = 1;
  }

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    display: flex;
    justify-content: center;
    list-style: none;
    margin-top: 20px;
    li a {
      padding: 5px 10px;
      border: 1px solid #ddd;
      margin: 0 4px;
      cursor: pointer;
      border-radius: 6px;
    }
    li.active a {
      background: #28a745;
      color: white;
      border: none;
    }
  `;

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleString();
  };

  return (
    <div id="main-wrapper">
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h4>Deposit Report</h4>
            </div>

            <div className="card-body">

              {/* FILTER */}
              <div className="row mb-3 ">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control col-md-3"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
           </div>             <div className="col-md-3">
                <input
                  type="date"
                  className="form-control col-md-3"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
 </div>             <div className="col-md-3">
                <input
                  type="date"
                  className="form-control col-md-3"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
 </div>             <div className="col-md-3">
                <button className="btn btn-success" onClick={handleSearch}>
                  Search
                </button>

                <button className="btn btn-info text-white" onClick={setThisWeek}>
                  This Week
                </button>

                <button className="btn btn-warning" onClick={setLastWeek}>
                  Last Week
                </button>

                <button className="btn btn-secondary" onClick={handleReset}>
                  Reset
                </button>
              </div>
              </div>

              {/* SUMMARY */}
              {summary && (
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="card p-2 text-center">
                      <small>Total Deposits</small>
                      <strong>{summary.totalAmount?.toFixed(2)}</strong>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card p-2 text-center">
                      <small>Total Bonus</small>
                      <strong>{summary.totalBonusAmount?.toFixed(2)}</strong>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card p-2 text-center">
                      <small>Users</small>
                      <strong>{summary.userCount}</strong>
                    </div>
                  </div>
                </div>
              )}

              {/* TABLE */}
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Method</th>
                      <th>Amount</th>
                      <th>Bonus</th>
                      <th>Txn</th>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((el, i) => (
                      <tr key={i}>
                        <td>{(currentPage.current - 1) * limit + i + 1}</td>
                        <td>{el.user_id}</td>
                        <td>{el.wallet_type}</td>
                        <td>{el.send_amount}</td>
                        <td>{el.send_amount_in_bdt}</td>
                        <td>{el.trxid}</td>
                        <td>{formatDate(el.createdAt)}</td>
                        <td style={{ color: el.status === "paid" ? "green" : "red" }}>
                          {el.status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <MyPaginate
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default List;